export default "__VITE_ASSET__DWz3pQXJ__"